import React from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { ItemTypes } from './ItemTypes';

const CircleShape = ({
  shape: { position, dimension, ...shape },
  isSelected,
  ...props
}) => {
  const [{ isDragging }, drag, preview] = useDrag(
    () => ({
      type: ItemTypes.SHAPE,
      item: {
        id: shape.id,
        position,
        name: shape.name,
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [shape.id, position.left, position.top, shape.name],
  );
  React.useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, []);
  let className = isSelected ? 'map-editor-shape--selected d-flex' : 'd-flex';
  let tagBoxStyle = {};
  if (shape.tagLocation !== 'None') {
    switch (shape.tagLocation) {
      case 'Top':
        className += ' flex-column';
        tagBoxStyle.width = '100%';
        tagBoxStyle.height = shape.tagBoxSize + '%';
        tagBoxStyle.borderTopLeftRadius = dimension.height;
        tagBoxStyle.borderTopRightRadius = dimension.height;
        break;
      case 'Right':
        className += ' flex-row-reverse';
        tagBoxStyle.height = '100%';
        tagBoxStyle.width = shape.tagBoxSize + '%';
        tagBoxStyle.borderTopRightRadius = dimension.height;
        tagBoxStyle.borderBottomRightRadius = dimension.height;
        break;
      case 'Bottom':
        className += ' flex-column-reverse';
        tagBoxStyle.width = '100%';
        tagBoxStyle.height = shape.tagBoxSize + '%';
        tagBoxStyle.borderBottomLeftRadius = dimension.height;
        tagBoxStyle.borderBottomRightRadius = dimension.height;
        break;
      case 'Center':
        className += ' justify-content-center align-items-center';
        tagBoxStyle.width = shape.tagBoxSize + '%';
        tagBoxStyle.height = shape.tagBoxSize + '%';
        break;
      default:
        className += ' flex-row';
        tagBoxStyle.height = '100%';
        tagBoxStyle.width = shape.tagBoxSize + '%';
        tagBoxStyle.borderTopLeftRadius = dimension.height;
        tagBoxStyle.borderBottomLeftRadius = dimension.height;
        break;
    }
  }
  return (
    <div
      key={shape.id}
      id={shape.id}
      ref={drag}
      role="Shape"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onSelectShape({ position, dimension, ...shape });
      }}
      className={className}
      style={{
        position: 'absolute',
        ...position,
        ...dimension,
        ...shape,
        borderRadius: '50%',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'black',
        overflow: 'hidden',
      }}
    >
      {shape.tagLocation !== 'None' ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            ...tagBoxStyle,
            backgroundColor: shape.tagBackGroundColor,
            overflowY: 'hidden',
            lineHeight: 1,
            wordBreak: 'break-all',
          }}
        >
          <span
            style={{
              fontSize: `${shape.tagFontSize}px`,
              color: shape.tagTextColor,
              fontFamily: shape.tagFontName,
            }}
          >
            {shape.tagText}
          </span>
        </div>
      ) : null}
      {shape.tagLocation === 'Center' ? null : (
        <div
          style={{
            display: 'flex',
            flex: 1,
            backgroundColor: shape.alarmBackgroundColor,
            // borderBottomLeftRadius: tagBoxStyle.borderTopLeftRadius,
            // borderBottomRightRadius: tagBoxStyle.borderTopRightRadius,
            // shape.valueBackGroundColor === 'alarm'
            //   ?
            //   : shape.valueBackGroundColor,
            // borderRadius: '50%',
          }}
        />
      )}
    </div>
  );
};

export default CircleShape;
